export default __webpack_public_path__ + "static/media/ann.c5e072ec.png";